/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentFormMessages.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Form Message API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Archetact ]
 *  
 *  Created:    Saturday, August 27, 2022 - 09:05:11 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      08/27/2022  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2022 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const FormMessages = {
    all: () => requests.get('/FormMessages'),
    get: formmessageid => requests.get(`/FormMessage/${formmessageid}`),
    create: formmessage => requests.post(`/FormMessages`, formmessage),
    send: formmessage => requests.post(`/SendFormMessage`, formmessage),
    update: (formmessageid, formmessage) => requests.put(`/FormMessage/${formmessageid}`, formmessage),
    markAsRead: (formmessageid) => requests.put(`/FormMessageReadFlag/${formmessageid}`, { "readflag": 1}),
    delete: formmessageid => requests.del(`/FormMessage/${formmessageid}`),
};